import React, { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../../components/api/ApiClient';
import BranchModal from '../dashboard/BranchModal';

function ProfileBranches() {
    const [branches, setBranches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState(null);

    const fetchBranches = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiClient('/companies/api/');
            setBranches(response.branches || []);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchBranches();
    }, [fetchBranches]);

    const handleCreateBranch = (e) => {
        e.preventDefault();
        setSelectedBranch(null);
        setModalVisible(true);
    };

    const handleEditBranch = (branch) => {
        setSelectedBranch(branch);
        setModalVisible(true);
    };

    const handleSaveBranch = () => {
        setModalVisible(false);
        fetchBranches();
    };

    if (loading) return <div className="col-xl-12"><div className="card stretch"><div className="card-body">در حال بارگذاری لیست شعب...</div></div></div>;
    if (error) return <div className="col-xl-12"><div className="card stretch"><div className="card-body alert alert-danger">خطا در بارگذاری شعب: {error}</div></div></div>;

    const renderBranchStatus = (isActive) => {
        if (isActive) {
            return <div className="badge bg-soft-success text-success">فعال</div>;
        } else {
            return <div className="badge bg-soft-warning text-warning">غیرفعال</div>;
        }
    };

    const renderContractStatus = (acceptContract) => {
        if (acceptContract) {
            return <div className="badge bg-soft-primary text-primary">پذیرفته شده</div>;
        } else {
            return <div className="badge bg-soft-danger text-danger">در انتظار</div>;
        }
    };

    return (
        <div className="col-xl-12">
            <div className="card stretch">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="card-title mb-0">لیست شعب</h5>
                    <button className="btn btn-primary" onClick={handleCreateBranch}>
                        <i className="feather-plus me-1"></i>
                        افزودن شعبه جدید
                    </button>
                </div>
                <div className="card-body custom-card-action p-0">
                    <div className="table-responsive project-report-table">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">نام شعبه</th>
                                    <th scope="col">کد حافظه مالیاتی</th>
                                    <th scope="col">وضعیت قرارداد</th>
                                    <th scope="col">وضعیت</th>
                                    <th scope="col" className="text-end">عملیات</th>
                                </tr>
                            </thead>
                            <tbody>
                                {branches.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="text-center text-muted">هیچ شعبه‌ای برای نمایش وجود ندارد.</td>
                                    </tr>
                                ) : (
                                    branches.map((branch) => (
                                        <tr key={branch.id} onClick={() => handleEditBranch(branch)} style={{ cursor: 'pointer' }}>
                                            <td>
                                                <div className="hstack gap-4">
                                                    <div>
                                                        <div className="fw-bold text-dark">{branch.name}</div>
                                                        <div className="fs-12 text-muted">کد: {branch.code || '-'}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td><span className="fw-bold text-dark">{branch.taxMemoryId || '-'}</span></td>
                                            <td>{renderContractStatus(branch.acceptContract)}</td>
                                            <td>{renderBranchStatus(branch.active)}</td>
                                            <td>
                                                <a href="#" className="avatar-text avatar-md ms-auto"><i className="feather-arrow-right"></i></a>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <BranchModal
                isVisible={modalVisible}
                onClose={() => setModalVisible(false)}
                initialData={selectedBranch}
                onSave={handleSaveBranch}
            />
        </div>
    );
}

export default ProfileBranches;
